<template>
  <div v-if="toshow" class="app" @scroll="pageScroll()">
    <sho></sho>

    <el-container @scroll="pageScroll()">
      <transition name="head">
        <el-header :style="headHidden" style="height: 50px">
          <Head></Head>
        </el-header>
      </transition>
      <el-main>
        <div class="prech"></div>
        <router-view> </router-view>
      </el-main>
      <el-footer>
        <Footer></Footer>
      </el-footer>
    </el-container>
    <oderModel></oderModel>
  </div>
</template>

<script>
import Head from "./components/Head.vue";
// import Main from "./components/Main.vue";
import Footer from "./components/Footer.vue";
import oderModel from "./components/common/oderModel.vue";
import sho from "./components/sho.vue";

export default {
  name: "app",
  // components: { Head, Main, Footer },
  components: { Head, Footer, oderModel, sho },
  data() {
    return {
      scrollValue: 0,
      toshow: false,
      headHidden:""
    };
  },
  methods: {
    pageScroll() {},
    //
    menu() {
      var now = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scrollValue - now < 0) {
        this.headHidden = 'height:0px'
      } else {
         this.headHidden = 'height:50px'
      }
      this.scrollValue = now;
    },
    debounce() {
      var that = this;
      let timeout = null; // 创建一个标记用来存放定时器的返回值
      return function () {
        clearTimeout(timeout); // 每当用户输入的时候把前一个 setTimeout clear 掉
        timeout = setTimeout(() => {
          // 然后又创建一个新的 setTimeout, 这样就能保证输入字符后的
          // interval 间隔内如果还有字符输入的话，就不会执行 fn 函数
          that.menu();
        }, 100);
      };
    },
    // 判断访问设备的函数
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
      );
      return flag;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.debounce());
    // 判断访问设备是移动端还是PC端
    if (this._isMobile()) {
      // 手机端
      // alert("手机")
      // this.$router.replace("/mobile/home");
      // let  url  = window.location.origin
      // url = url + "/wap/mobile_card/#/index"
      let url = window.location.href;
      url = url.replace("activity/specialtraining", "wap/mobile_card");
      window.location.href = url;
    } else {
      // pc端
      //  alert("PC端")
      // this.$router.replace("/");
    }
  },
  created() {
    var loading = this.$loading({
      lock: true,
      text: "加载中",
      spinner: "el-icon-loading",
      background: "rgba(255, 255, 255, 1)",
    });
    var th_is = this;

    setTimeout(function () {
      th_is.toshow = true;
    }, 500);
    setTimeout(function () {
      loading.close();
    }, 1000);
  },
};
</script>

<style lang="less">
@import url("./assets/common/common.css");
@import url("./assets/common/fontFamily.css");

html {
  height: auto;
  // width: 120rem;
  margin: 0;
  padding: 0;

  // 使所有文字都不能选中
  // -webkit-touch-callout: none;
  // -webkit-user-select: none;
  // -moz-user-select: none;
  // -ms-user-select: none;
  // user-select: none;
}
body {
  width: 100%;
  height: 100%;
}
.app {
  width: 100%;
  height: 100%;
  .el-container {
    width: 100%;
    height: 100%;

    .el-header {
      z-index: 999;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #ffffff;
      overflow: hidden;
      transition: all 0.7s;
      -moz-transition: all 0.7s; /* Firefox 4 */
      -webkit-transition: all 0.7s; /* Safari 和 Chrome */
      -o-transition: all 0.7s; /* Opera */
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
      &:hover{
        overflow: initial;
      }
    }
    .el-main {
      background-color: #f9f9f9;
      overflow: hidden;
      .prech {
        width: 100%;
        height: 3.125rem;
      }
    }
    .el-footer {
      background-color: #f8f8f8;
    }

    .el-footer,
    .el-main,
    .el-header {
      margin: 0;
      padding: 0;
    }
  }
}
</style>
